import React, { useEffect, useRef } from 'react';

const BackgroundCanvas = () => {
    const canvasRef         = useRef(null);
    const animationFrameRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        let W, H;

        function resize() {
            W = canvas.width  = window.innerWidth;
            H = canvas.height = window.innerHeight;
        }
        resize();

        const N = 110;
        const nodes = Array.from({ length: N }, () => {
            const cx = Math.random() * window.innerWidth;
            const cy = Math.random() * window.innerHeight;
            const orbitR = Math.random() * 55 + 12;
            const angle  = Math.random() * Math.PI * 2;
            const speed  = (Math.random() > 0.5 ? 1 : -1) * (0.0015 + Math.random() * 0.003);
            return {
                cx, cy, orbitR, angle, speed,
                driftVx: (Math.random() - 0.5) * 0.12,
                driftVy: (Math.random() - 0.5) * 0.12,
                r: Math.random() * 2.8 + 1.4,
                x: cx + Math.cos(angle) * orbitR,
                y: cy + Math.sin(angle) * orbitR,
            };
        });

        function handleResize() {
            resize();
            nodes.forEach(n => {
                n.cx = Math.min(Math.max(n.cx, 0), W);
                n.cy = Math.min(Math.max(n.cy, 0), H);
            });
        }

        function draw() {
            ctx.clearRect(0, 0, W, H);

            nodes.forEach(n => {
                n.angle += n.speed;
                n.x = n.cx + Math.cos(n.angle) * n.orbitR;
                n.y = n.cy + Math.sin(n.angle) * n.orbitR;
                n.cx += n.driftVx; n.cy += n.driftVy;
                if (n.cx < -60) n.cx = W + 60; if (n.cx > W + 60) n.cx = -60;
                if (n.cy < -60) n.cy = H + 60; if (n.cy > H + 60) n.cy = -60;
            });

            // Connecting lines
            for (let i = 0; i < N; i++) {
                for (let j = i + 1; j < N; j++) {
                    const d = Math.hypot(nodes[i].x - nodes[j].x, nodes[i].y - nodes[j].y);
                    if (d < 100) {
                        const alpha = 0.06 * (1 - d / 100);
                        ctx.beginPath();
                        ctx.moveTo(nodes[i].x, nodes[i].y);
                        ctx.lineTo(nodes[j].x, nodes[j].y);
                        ctx.strokeStyle = `rgba(255,255,255,${alpha})`;
                        ctx.lineWidth = 0.5;
                        ctx.stroke();
                    }
                }
            }

            // Dots
            nodes.forEach(n => {
                ctx.beginPath();
                ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(175,175,175,0.55)';
                ctx.fill();
            });

            animationFrameRef.current = requestAnimationFrame(draw);
        }

        window.addEventListener('resize', handleResize);
        draw();

        return () => {
            window.removeEventListener('resize', handleResize);
            if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
        };
    }, []);

    return (
        <canvas ref={canvasRef} id="bg-canvas" width="1920" height="993"></canvas>
    );
};

export default BackgroundCanvas;